import { useState } from 'react'

import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

/**این کامپوننت برای اینپوت کارت بانکی است */
const InputBankCard = ({ label, Placeholder, name, defaultValue, handelValue, disabled, autoComplete }) => {

    const [error, setError] = useState("")

    const [colorerror, setColorerror] = useState('')

    const pattern = new RegExp(/^[0-9]+$/);


    const hedelonCheng = (event) => {

        if (event.target.value) {

            const vlaue = event.target.value

            if (pattern.test(vlaue)) {
                if (vlaue.length > 0 && vlaue.length < 16) {
                    setError('شماره کارت  باید 16 رقم باشد')
                    setColorerror('red')
                }
                else {
                    setError('شماره کارت قابل ثبت است')
                    setColorerror('green')
                    handelValue(name, vlaue)
                }
            }
            else {
                setError('شماره کارت فقط به عدد قابل ثبت است')
                setColorerror('red')
            }


        }
        else {
            setError('')
            setColorerror('')
            handelValue(name, '')
        }
    }

    return (
        <Form.Group>
            <div className='d-flex'>
                {
                    label ? <Form.Label>{label}</Form.Label>
                        : null
                }
            </div>
            <Form.Control
                disabled={disabled}
                type="text"
                dir='ltr'
                maxLength={16}
                autoComplete={autoComplete ? "off" : "on"}
                placeholder={Placeholder ? Placeholder : ""}
                name={name ? name : ""}
                defaultValue={defaultValue ? defaultValue : ""}
                onChange={hedelonCheng} />

            {error ? <Form.Text style={{ color: colorerror }} >{error}</Form.Text> : null}

        </Form.Group>
    )
}

export default InputBankCard;

InputBankCard.propTypes = {
    /**لیبل اینپوت است */
    label: PropTypes.string,
    /**برای ارسال مقدار اولیه برای اینپوت است */
    defaultValue: PropTypes.number,
    /** مقدار هلدر اینپوت است */
    Placeholder: PropTypes.string,
    /** نام اینپوت است */
    name: PropTypes.string,
    /** ارسال مقدار اینپوت به بالا است */
    handelValue: PropTypes.func
};